import { Api } from '@/services/Api'

export default {
  getNifpsData (plantId) {
    return Api().get(`api/v2/nifps/live-data/${plantId}`)
  },
  getBlockList(plantId) {
    return Api().get(`/api/v1.0/block_list/${plantId}/nifps`)
  },
}